<div class="modal-wrapper">
    <div modal class="modal" *ngIf="modals.settings !== undefined">
        <div class="modal-background" (click)="closeModal('settings')"></div>
        <div class="modal-container settings-modal-container">
            <settings
                (close)="closeModal('settings')"
                [input]="modals.settings"></settings>
        </div>
    </div>

    <div modal class="modal" *ngIf="modals.successModal">
        {{ modals.successModal }}
        <div
            class="modal-background"
            (click)="closeModal('successModal')"
            av-data="close-success-modal"></div>
        <div class="modal-container settings-modal-container">
            <success-modal
                [params]="modals.successModal"
                (close)="closeModal('successModal')"></success-modal>
        </div>
    </div>

    <div modal class="rename-modal modal" *ngIf="modals.rename !== undefined">
        <div class="modal-background" (click)="closeModal('rename')"></div>
        <div class="modal-container">
            <rename
                (close)="closeModal('rename')"
                [renameModal]="modals.rename"></rename>
        </div>
    </div>

    <div modal class="modal" *ngIf="modals.desktopAppBugReport$">
        <div
            class="modal-background"
            (click)="closeModal('desktopAppBugReport$')"></div>
        <div class="modal-container">
            <desktop-app-bug-report-modal
                (close)="
                    closeModal('desktopAppBugReport$')
                "></desktop-app-bug-report-modal>
        </div>
    </div>

    <div modal class="modal simple-modal" *ngIf="modals.simpleModal != null">
        <div class="modal-background" (click)="closeModal('simpleModal')"></div>
        <div class="modal-container">
            <simple-modal
                (close)="closeModal('simpleModal')"
                [simpleModal]="modals.simpleModal"></simple-modal>
        </div>
    </div>

    <div
        modal
        class="instrument-selection-modal modal"
        *ngIf="modals.instrumentSelectionCompositionWorkflows !== undefined">
        <div
            class="modal-background"
            (click)="
                closeModal('instrumentSelectionCompositionWorkflows')
            "></div>
        <div class="modal-container">
            <instrument-selection-composition-workflows
                [parameters]="modals.instrumentSelectionCompositionWorkflows"
                (close)="
                    closeModal('instrumentSelectionCompositionWorkflows')
                "></instrument-selection-composition-workflows>
        </div>
    </div>

    <div modal class="autofill-modal modal" *ngIf="modals.autofill != null">
        <div class="modal-background" (click)="closeModal('autofill')"></div>
        <div class="modal-container">
            <autofill (close)="closeModal('autofill')"></autofill>
        </div>
    </div>

    <div modal class="subscription-modal modal" *ngIf="subscriptionModal">
        <div class="modal-background" (click)="closeSubscriptionModal()"></div>
        <div class="modal-container">
            <div class="modal-title">Upgrade to access this feature</div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="closeSubscriptionModal()" />
            </div>
            <div class="modal-subtitle">{{ subscriptionModalDescription }}</div>
            <div class="modal-embed" *ngIf="subscriptionEmbed != ''">
                <img
                    src="{{ subscriptionEmbed }}"
                    (click)="clickEmbeddedLink()" />
            </div>

            <div
                class="modal-button modal-green-button"
                (click)="viewSubscriptionPlans()">
                View Subscription Plans
            </div>
        </div>
    </div>

    <div
        modal
        class="modal do-action-before-modal"
        *ngIf="modals.doActionsBefore !== undefined">
        <do-action-before
            [input]="modals.doActionsBefore"
            (close)="closeModal('doActionsBefore')"></do-action-before>
    </div>

    <div modal class="modal changelog-modal" *ngIf="modals.changelog">
        <div class="modal-background" (click)="closeModal('changelog')"></div>
        <div class="modal-container">
            <changelog (close)="closeModal('changelog')"></changelog>
        </div>
    </div>

    <div modal class="modal compatibility-modal" *ngIf="compatibilityModal">
        <div class="modal-background" (click)="closeCompatibilityModal()"></div>
        <div class="modal-container">
            <div class="modal-title">
                Your browser is not compatible with this feature
            </div>
            <div class="modal-subtitle">
                Editing features require the use of an up-to-date web browser.
                We recommend the following:
            </div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="closeCompatibilityModal()" />
            </div>

            <div class="browser-list">
                <div class="browser-item">
                    <img src="assets/img/browsers/chrome.svg" />
                    <div class="browser-item-version">
                        Chrome version 85 or later
                    </div>
                </div>

                <div class="browser-item">
                    <img src="assets/img/browsers/safari.svg" />
                    <div class="browser-item-version">
                        Safari version 13 or later
                    </div>
                </div>

                <div class="browser-item">
                    <img src="assets/img/browsers/firefox.svg" />
                    <div class="browser-item-version">
                        Firefox version 80 or later
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div modal class="modal delete-modal" *ngIf="deleteFolder">
        <div class="modal-background" (click)="deleteFolder = false"></div>
        <div class="modal-container">
            <div class="modal-title">Confirm deletion</div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="deleteFolder = false" />
            </div>
            <div class="modal-subtitle">
                This action is irreversible, and will also delete ALL elements
                contained in the folder.
            </div>

            <div
                class="modal-button modal-text-button"
                (click)="deleteFolder = false">
                Cancel
            </div>
            <div
                class="modal-button modal-red-button"
                (click)="confirmDeleteFolder()">
                Delete
            </div>
        </div>
    </div>

    <div modal class="modal delete-modal" *ngIf="deleteMulti">
        <div class="modal-background" (click)="closeDeleteMulti()"></div>
        <div class="modal-container">
            <div class="modal-title">Confirm deletion</div>
            <div class="modal-close">
                <img src="assets/img/close.svg" (click)="closeDeleteMulti()" />
            </div>
            <div class="modal-subtitle">
                This action is irreversible, and will delete ALL elements
                selected, including elements contained in any selected folder.
            </div>

            <div
                class="modal-button modal-text-button"
                (click)="closeDeleteMulti()">
                Cancel
            </div>
            <div
                class="modal-button modal-red-button"
                (click)="confirmDeleteMulti()">
                Delete
            </div>
        </div>
    </div>

    <div modal class="modal update-modal" *ngIf="updateModal">
        <div class="modal-background"></div>
        <div class="modal-container">
            <div class="modal-title">AIVA has been updated!</div>
            <div class="modal-subtitle">
                To enjoy the latest version and carry on composing music, please
                refresh your browser page.
            </div>
        </div>
    </div>

    <div
        modal
        class="modal update-modal"
        *ngIf="modals.outdatedDesktopApp !== false">
        <div class="modal-background"></div>
        <div class="modal-container">
            <div class="modal-title">Your desktop app is out of date</div>
            <div class="modal-subtitle">
                Please install the latest version of the desktop app to continue
                using AIVA.

                <div class="outdated-modal-buttons">
                    <a-button
                        label="Download app update"
                        (click)="downloadBinaries()"
                        width="100%"
                        type="secondary"></a-button>
                </div>
            </div>
        </div>
    </div>

    <div modal class="billing-preview-modal modal" *ngIf="billingPreviewModal">
        <div
            class="modal-background"
            (click)="billingPreviewModal = false"></div>
        <div class="modal-container">
            <div
                class="modal-title modal-title-billing-preview"
                *ngIf="!billingPreviewLoading">
                Confirm your subscription
            </div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="billingPreviewModal = false" />
            </div>

            <!-- in case of a downgrade -->
            <div
                class="preview-container"
                *ngIf="
                    billingPreview.preview.isDowngrade && !billingPreviewLoading
                ">
                <div class="downgrade-explanation">
                    By downgrading to this plan, you will continue enjoying your
                    current subscription until the end of your billing cycle ({{
                        billingPreview.preview.subscriptionEnd
                            | date : "mediumDate"
                    }}), and will be automatically switched to the new plan on
                    that same date.
                </div>

                <!-- open the downgrade survey -->
                <a-button
                    width="100%"
                    label="Downgrade"
                    class="plan-button plan-button-downgrade"
                    (onClick)="showDowngradeSubscriptionSurvey()"></a-button>
            </div>

            <!-- when upgrading or creating a subscription, this window will show us the billing preview -->
            <div
                class="preview-container"
                *ngIf="
                    !billingPreview.preview.isDowngrade &&
                    !billingPreviewLoading
                ">
                <div
                    class="preview-item"
                    *ngIf="billingPreview.preview.startingBalance != 0">
                    <div
                        class="preview-line-item"
                        *ngIf="billingPreview.preview.startingBalance < 0">
                        <div class="preview-item-description">
                            Starting balance
                        </div>
                        <div class="preview-item-amount">
                            - €
                            {{
                                formatAmount(
                                    billingPreview.preview.startingBalance
                                )
                            }}
                        </div>
                    </div>

                    <div
                        class="preview-line-item"
                        *ngIf="billingPreview.preview.startingBalance > 0">
                        <div class="preview-item-description">
                            Starting balance
                        </div>
                        <div class="preview-item-amount">
                            € {{
                                formatAmount(
                                    billingPreview.preview.startingBalance
                                )
                            }}
                        </div>
                    </div>
                </div>

                <div
                    class="preview-item"
                    *ngFor="
                        let line of billingPreview.preview.previewLines;
                        let i = index
                    ">
                    <div
                        class="preview-line-item"
                        *ngIf="line.amount <= 0 && !line.tax">
                        <div class="preview-item-description">
                            Unused time on
                            <span id="subscription-plan">{{
                                formatPlanName(line.plan.name)
                            }}</span>
                            after {{ line.period.start | date : "mediumDate" }}
                        </div>
                        <div class="preview-item-amount">
                            - € {{ formatAmount(line.amount) }}
                        </div>
                    </div>

                    <div
                        class="preview-line-item"
                        *ngIf="line.amount > 0 && !line.tax">
                        <div class="preview-item-description">
                            Recurring subscription to
                            <span id="subscription-plan">{{
                                formatPlanName(line.plan.name)
                            }}</span
                            >, starting
                            {{ line.period.start | date : "mediumDate" }}
                        </div>
                        <div class="preview-item-amount">
                            € {{ formatAmount(line.amount) }}
                        </div>
                    </div>

                    <div class="preview-line-item" *ngIf="line.tax">
                        <div class="preview-item-description">
                            {{ line.vatType }}
                            <span *ngIf="line.amount < 0"
                                >(Proration adjustment)</span
                            >
                        </div>
                        <div class="preview-item-amount">
                            <span *ngIf="line.amount < 0">-</span> € {{
                                formatAmount(line.amount)
                            }}
                        </div>
                    </div>
                </div>

                <div class="preview-item-total">
                    <div class="preview-item-total-title">Total:</div>
                    <div
                        class="preview-item-amount"
                        *ngIf="getPreviewTotal() >= 0">
                        € {{ formatAmount(getPreviewTotal()) }}
                    </div>
                    <div
                        class="preview-item-amount"
                        *ngIf="getPreviewTotal() < 0">
                        - € {{ formatAmount(getPreviewTotal()) }}
                    </div>
                </div>

                <div class="balance-description" *ngIf="getPreviewTotal() < 0">
                    Negative balance is non-refundable, but will be used as
                    credit towards any future subscription payments.
                </div>

                <a-button
                    class="primary subscription-primary-button"
                    width="100%"
                    (onClick)="changeSubscription(billingPreview.plan)"
                    [label]="'Subscribe'"></a-button>

                <div class="payment-disclaimer">
                    By clicking on subscribe, you accept the refund policy
                    stated in our
                    <a href="https://www.aiva.ai/legal/1"
                        >End User License Agreement</a
                    >.
                </div>
            </div>

            <!-- this shows while we are waiting for the billing preview to load -->
            <div class="loader-container" *ngIf="billingPreviewLoading">
                <div class="loader"></div>

                <div class="close-warning">
                    Please keep this page open until the checkout is completed
                </div>
            </div>
        </div>
    </div>

    <div
        modal
        class="downgrade-subscription-survey-modal modal"
        *ngIf="downgradeSubscriptionSurveyModal">
        <div
            class="modal-background"
            (click)="downgradeSubscriptionSurveyModal = false"></div>
        <div class="modal-container">
            <div class="modal-title modal-title-downgrade-survey"></div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="downgradeSubscriptionSurveyModal = false" />
            </div>

            <div class="emoji-image">😢</div>
            <div class="title">We're sorry to see you downgrade</div>
            <div class="sub-title">
                We value our customers’ input greatly. You can help us improve
                our services by letting us know why you would like to downgrade.
            </div>

            <div class="option-box">
                <div
                    class="radio-option"
                    *ngFor="let reason of downgradeSurveyReasons"
                    (click)="downgradeSurveyReasonChanged()">
                    <input
                        [id]="reason.value"
                        type="radio"
                        name="reason"
                        [value]="reason.value"
                        [(ngModel)]="downgradeSurvey.reason" />
                    <label for="{{ reason.value }}">{{ reason.label }}</label>
                </div>
            </div>

            <div
                class="required-fields-hint"
                *ngIf="downgradeSurvey.reason == ''">
                *Please select the most fitting reason to continue.
            </div>

            <div class="explanation-box">
                <textarea
                    name="explanation"
                    id="explanation"
                    cols="30"
                    rows="4"
                    placeholder="Anything you want to share?"
                    [(ngModel)]="downgradeSurvey.explanation"></textarea>
            </div>

            <div
                class="required-fields-hint"
                *ngIf="
                    downgradeSurvey.reason == 'other' &&
                    downgradeSurvey.explanation.length < 3
                ">
                *Please fill in an additonal explanation.
            </div>

            <div class="button-box">
                <a-button
                    class="downgrade"
                    label="Downgrade"
                    [disabled]="
                        downgradeSurvey.reason == '' ||
                        (downgradeSurvey.reason == 'other' &&
                            downgradeSurvey.explanation.length < 3)
                    "
                    (click)="changeSubscription()"></a-button>
                <div
                    class="dont-cancel"
                    (click)="downgradeSubscriptionSurveyModal = false">
                    Nevermind, I don't want to downgrade.
                </div>
            </div>
        </div>
    </div>

    <div
        modal
        class="subscription-status-info-modal modal"
        *ngIf="subscriptionStatusInfoModal">
        <div
            class="modal-background"
            (click)="subscriptionStatusInfoModal = false"></div>
        <div class="modal-container">
            <div class="checkmark-icon" *ngIf="subscriptionStatus == 'success'">
                <svg
                    class="checkmark-green"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52">
                    <circle
                        class="checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none" />
                    <path
                        class="checkmark__check"
                        fill="transparent"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
            </div>
            <div class="cross-icon" *ngIf="subscriptionStatus == 'error'">
                <svg
                    class="cross-red"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52">
                    <circle
                        class="cross__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none" />
                    <path
                        class="cross__crossed"
                        fill="none"
                        d="M16 16 36 36 M36 16 16 36" />
                </svg>
            </div>

            <div class="modal-title" *ngIf="subscriptionStatus == 'success'">
                Thank you! :)
            </div>
            <div class="modal-title" *ngIf="subscriptionStatus == 'error'">
                What a bummer :(
            </div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="subscriptionStatusInfoModal = false" />
            </div>

            <div class="status-text" *ngIf="subscriptionStatus == 'success'">
                <div *ngIf="!subscriptionIsDowngrade">
                    Your subscription was successfully activated. Enjoy your
                    {{ subscribedToPlan }} plan!
                </div>
                <div *ngIf="subscriptionIsDowngrade">
                    You will be downgraded to the {{ subscribedToPlan }} plan on
                    {{ subscriptionEnd }}.
                </div>
            </div>
            <div class="status-text" *ngIf="subscriptionStatus == 'error'">
                Something went wrong. Please try again or contact Support.
            </div>
        </div>
    </div>

    <div modal class="download-modal modal" *ngIf="downloadModal">
        <div class="modal-background" (click)="closeDownloadModal()"></div>
        <div class="modal-container">
            <ng-container *ngIf="!downloadLoading">
                <div
                    class="modal-title modal-preset-title"
                    *ngIf="!selectStemsType">
                    Download Composition
                </div>
                <div
                    class="modal-title modal-preset-title"
                    *ngIf="selectStemsType">
                    <img src="assets/img/format/stems.svg" /> Stems Grouping
                </div>
                <div class="modal-close">
                    <img
                        src="assets/img/close.svg"
                        (click)="closeDownloadModal()" />
                </div>

                <div *ngIf="!selectStemsType">
                    <div id="types-list">
                        <div class="download-subtitle">
                            Download single files
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadFile('mp3')">
                            <img src="assets/img/format/mp3.svg" />
                            <div class="download-type-title">MP3</div>
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadFile('orchestrated-midi')">
                            <img src="assets/img/format/midi.svg" />
                            <div class="download-type-title">
                                Orchestrated MIDI
                            </div>
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadFile('reduced-midi')">
                            <img src="assets/img/format/midi.svg" />
                            <div class="download-type-title">Reduced MIDI</div>
                        </div>

                        <div
                            class="download-type download-type-disabled tooltip"
                            *ngIf="showExportWAVOption()"
                            (click)="downloadFile('wav')">
                            <span class="tooltiptext"
                                >In order to download a WAV file, you first need
                                to render it using the "Render Uncompressed WAV"
                                button below.</span
                            >
                            <img src="assets/img/format/wav.svg" />
                            <div class="download-type-title">WAV</div>
                        </div>

                        <div
                            class="download-type"
                            *ngIf="!showExportWAVOption()"
                            (click)="downloadFile('wav')">
                            <img src="assets/img/format/wav.svg" />
                            <div class="download-type-title">WAV</div>
                        </div>

                        <div
                            class="download-type download-type-disabled tooltip"
                            *ngIf="showExportStemsOption()">
                            <span class="tooltiptext"
                                >In order to download Stems, you first need to
                                render it using the "Render Stems" button
                                below.</span
                            >
                            <img src="assets/img/format/stems.svg" />
                            <div class="download-type-title">Stems</div>
                        </div>

                        <div
                            class="download-type"
                            *ngIf="!showExportStemsOption()"
                            (click)="downloadFile('stems')">
                            <img src="assets/img/format/stems.svg" />
                            <div class="download-type-title">Stems</div>
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadFile('chords')">
                            <img src="assets/img/format/chords.svg" />
                            <div class="download-type-title">Chords</div>
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadFile('json')"
                            *ngIf="showJSONOption()">
                            <div class="download-type-title">JSON</div>
                        </div>

                        <div
                            class="download-type"
                            (click)="downloadBugReport()"
                            *ngIf="showJSONOption()">
                            <div class="download-type-title">Bug report</div>
                        </div>

                        <div class="download-subtitle">Other actions</div>

                        <div
                            class="download-type download-all export-wav"
                            (click)="downloadFile('all')">
                            <img src="assets/img/format/zip.svg" />
                            <div class="download-type-title">
                                Download zip (MP3 + MIDI)
                            </div>
                        </div>

                        <div
                            class="download-type download-all export-wav"
                            *ngIf="showExportWAVOption()"
                            (click)="exportWAV()">
                            <img src="assets/img/format/wav.svg" />
                            <div class="download-type-title">
                                Render Uncompressed WAV (16 bit, 44.1kHz)
                            </div>
                        </div>

                        <div
                            class="download-type download-all export-wav"
                            (click)="selectStemsType = !selectStemsType">
                            <img src="assets/img/format/stems.svg" />
                            <div class="download-type-title">
                                Render Stems (16 bit WAV)
                            </div>
                        </div>
                    </div>

                    <div id="download-bottom-container">
                        <div class="download-bottom-subcontainer">
                            <div class="download-subtitle">License:</div>
                            <div class="download-quota-remaining">
                                <span class="license-capitalization">{{
                                    getDownloadLicense()
                                }}</span
                                ><span *ngIf="showUpgradeSubscription()"
                                    >. To own the full copyright of this track,
                                    please
                                    <div
                                        class="download-upgrade-license text-button green-text-button"
                                        (click)="viewSubscriptionPlans()">
                                        Upgrade your Subscription
                                    </div>
                                    .</span
                                >
                            </div>
                        </div>

                        <div class="download-bottom-subcontainer">
                            <div class="download-subtitle">Monthly Quota:</div>
                            <div
                                class="download-quota-remaining"
                                *ngIf="!alreadyDownloadedComposition()">
                                You can download {{ getDownloadsLeft() }} more
                                composition(s) this month. Downloading the same
                                composition multiple times will only count as
                                one download.
                            </div>
                            <div
                                class="download-quota-remaining"
                                *ngIf="alreadyDownloadedComposition()">
                                You already downloaded this track. Downloading
                                again won't count towards your quota.
                            </div>
                        </div>
                    </div>

                    <div
                        id="download-filename-parameters"
                        (click)="addParamsToFilename = !addParamsToFilename">
                        <input
                            type="checkbox"
                            [(ngModel)]="addParamsToFilename" />
                        Add composition parameters to the file name
                    </div>
                </div>

                <div *ngIf="selectStemsType">
                    <div
                        class="stems-group-type"
                        (click)="stemsTypeSelection('layer')">
                        <img src="assets/img/format/layer.svg" />
                        <div class="stems-group-type-title">
                            Group by layer
                            <span
                                class="stems-group-type-subtitle"
                                *ngIf="recommendedStems() == 'layer'"
                                >Recommended for this composition</span
                            >
                        </div>
                    </div>

                    <div
                        class="stems-group-type"
                        (click)="stemsTypeSelection('section')">
                        <img src="assets/img/format/pie_chart.svg" />
                        <div class="stems-group-type-title">
                            Group by instrument section
                            <span
                                class="stems-group-type-subtitle"
                                *ngIf="recommendedStems() == 'section'"
                                >Recommended for this composition</span
                            >
                        </div>
                    </div>

                    <div
                        class="stems-group-type"
                        (click)="stemsTypeSelection('instrument')">
                        <img src="assets/img/instruments/brass.svg" />
                        <div class="stems-group-type-title">
                            Group by instrument
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="loader-container" *ngIf="downloadLoading">
                <div class="loader"></div>

                Loading, please wait
            </div>
        </div>
    </div>

    <div modal class="download-modal modal" *ngIf="downloadFolderModal">
        <div
            class="modal-background"
            (click)="downloadFolderModal = false"></div>
        <div class="modal-container">
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="downloadFolderModal = false" />
            </div>

            <div *ngIf="selectedFolderType == null">
                <div
                    class="modal-title modal-preset-title"
                    *ngIf="!downloadFolderModalLoading">
                    Select File Type
                </div>
                <div id="types-list" *ngIf="!downloadFolderModalLoading">
                    <div
                        class="download-type"
                        (click)="setSelectFolderType('mp3')">
                        <img src="assets/img/format/mp3.svg" />
                        <div class="download-type-title">Compressed MP3</div>
                    </div>

                    <div
                        class="download-type"
                        (click)="setSelectFolderType('orchestrated-midi')">
                        <img src="assets/img/format/midi.svg" />
                        <div class="download-type-title">Orchestrated Midi</div>
                    </div>

                    <div
                        class="download-type"
                        (click)="setSelectFolderType('piano-midi')">
                        <img src="assets/img/format/midi.svg" />
                        <div class="download-type-title">Reduced Midi</div>
                    </div>

                    <div
                        class="download-type"
                        (click)="setSelectFolderType('json')"
                        *ngIf="showJSONOption()">
                        <div class="download-type-title">JSON</div>
                    </div>
                </div>

                <div
                    id="download-filename-parameters"
                    *ngIf="!downloadFolderModalLoading"
                    (click)="
                        addParamsToFilenameFolder = !addParamsToFilenameFolder
                    ">
                    <input
                        type="checkbox"
                        [(ngModel)]="addParamsToFilenameFolder" />
                    Add composition parameters to file names
                </div>
            </div>

            <div
                *ngIf="
                    selectedFolderType != null && !downloadFolderModalLoading
                ">
                <div class="folder-download-warning">
                    <img src="assets/img/warning.svg" />
                    Downloading this folder will count as
                    {{ numberOfUndownloadedCompositionsInFolder }} compositions
                    towards your quota.
                </div>

                <div
                    class="modal-button modal-grey-button"
                    (click)="downloadFolderModal = false">
                    Cancel
                </div>

                <div
                    class="modal-button modal-green-button"
                    (click)="downloadFolder()">
                    Proceed with download
                </div>
            </div>

            <div
                class="modal-title modal-preset-title"
                *ngIf="downloadFolderModalLoading">
                Download in progress...
            </div>

            <div class="loader-container" *ngIf="downloadFolderModalLoading">
                <div class="loader"></div>
                <br />
                Please keep this browser page open. This may take some time
                depending on the number of compositions.
            </div>
        </div>
    </div>

    <div modal class="rename-modal modal" *ngIf="renameModal">
        <div class="modal-background" (click)="cancelRename()"></div>
        <div class="modal-container">
            <div class="modal-title">Rename</div>
            <div class="modal-close">
                <img src="assets/img/close.svg" (click)="cancelRename()" />
            </div>
            <input
                type="text"
                class="modal-input"
                name="newName"
                #renameField
                [(ngModel)]="newName"
                (keydown.enter)="rename()"
                av-data="renameInput" />

            <div
                class="modal-button modal-text-button"
                (click)="cancelRename()">
                Cancel
            </div>
            <div
                class="modal-button modal-blue-button"
                (click)="rename()"
                av-data="renameConfirm">
                Done
            </div>
        </div>
    </div>

    <div modal class="modal password-modal" *ngIf="changePasswordModal">
        <div
            class="modal-background"
            (click)="changePasswordModal = false"></div>
        <div class="modal-container">
            <div class="modal-title">Change my Password</div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="changePasswordModal = false" />
            </div>
            <div class="password-form">
                <input
                    type="password"
                    class="input"
                    name="currentPassword"
                    autocomplete="current-password"
                    placeholder="Current password"
                    [(ngModel)]="passwords.currentPassword" />
                <input
                    type="password"
                    class="input"
                    name="newPassword"
                    autocomplete="new-password"
                    placeholder="New password"
                    [(ngModel)]="passwords.newPassword" />
                <input
                    type="password"
                    class="input"
                    name="newPasswordConfirm"
                    autocomplete="new-password"
                    placeholder="Confirm new password"
                    [(ngModel)]="passwords.newPasswordConfirm"
                    (keydown.enter)="changePassword()" />
            </div>

            <div
                class="modal-button modal-text-button"
                (click)="changePasswordModal = false">
                Cancel
            </div>
            <div
                class="modal-button modal-blue-button"
                (click)="changePassword()">
                Done
            </div>
        </div>
    </div>

    <div modal class="rename-modal modal" *ngIf="renameFolderModal">
        <div class="modal-background" (click)="cancelRename()"></div>
        <div class="modal-container">
            <div class="modal-title">Rename</div>
            <div class="modal-close">
                <img src="assets/img/close.svg" (click)="cancelRename()" />
            </div>
            <input
                type="text"
                class="modal-input"
                #renameFolderField
                name="newName"
                [(ngModel)]="newFolderName"
                (keydown.enter)="renameFolder()" />

            <div
                class="modal-button modal-text-button"
                (click)="cancelRename()">
                Cancel
            </div>
            <div
                class="modal-button modal-blue-button"
                (click)="renameFolder()">
                Done
            </div>
        </div>
    </div>

    <div modal class="modal share-modal" *ngIf="shareModal">
        <div class="modal-background" (click)="closeShareModals()"></div>
        <div class="modal-container">
            <div class="modal-title">Share</div>
            <div class="modal-close">
                <img src="assets/img/close.svg" (click)="closeShareModals()" />
            </div>

            <div
                class="message-box"
                *ngIf="message.show && !shareLoading"
                [ngClass]="message.type">
                <div class="close-button" (click)="message.show = false">
                    <img src="assets/img/close.svg" />
                </div>
                <div class="text">{{ message.text }}</div>
            </div>
            <div class="loader-container" *ngIf="shareLoading">
                <div class="loader"></div>
            </div>

            <div class="share-header">
                <div class="link-sharing-subheader">Link Sharing -</div>
                <div
                    class="link-sharing-subheader link-sharing-button"
                    *ngIf="linkSharingIsEnabled()"
                    (click)="toggleLinkSharing(false)">
                    Disable
                </div>
                <div
                    class="link-sharing-subheader link-sharing-button"
                    *ngIf="!linkSharingIsEnabled()"
                    (click)="toggleLinkSharing(true)">
                    Enable
                </div>
            </div>

            <div
                class="link-sharing-input"
                ngxClipboard
                [cbContent]="getSharedLink()"
                (click)="linkCopied = true">
                {{ getSharedLink() }}
            </div>

            <div *ngIf="linkCopied" class="link-copied">
                <img src="assets/img/menu/link.svg" />
                Link copied to your clipboard!
            </div>
        </div>
    </div>

    <!-- share folder as playlist -->
    <div modal class="modal share-folder-modal" *ngIf="shareFolderModal">
        <div class="modal-background" (click)="closeShareModals()"></div>
        <div class="modal-container">
            <div class="modal-title">Share folder as playlist</div>
            <div class="modal-close">
                <img src="assets/img/close.svg" (click)="closeShareModals()" />
            </div>

            <div
                class="message-box"
                *ngIf="message.show && !shareLoading"
                [ngClass]="message.type">
                <div class="close-button" (click)="message.show = false">
                    <img src="assets/img/close.svg" />
                </div>
                <div class="text">{{ message.text }}</div>
            </div>
            <div class="loader-container" *ngIf="shareLoading">
                <div class="loader"></div>
            </div>

            <div class="share-header">
                <div class="link-sharing-subheader">Link Sharing -</div>
                <div
                    class="link-sharing-subheader link-sharing-button"
                    *ngIf="folderLinkSharingIsEnabled"
                    (click)="toggleFolderLinkSharing(false)">
                    Disable
                </div>
                <div
                    class="link-sharing-subheader link-sharing-button"
                    *ngIf="!folderLinkSharingIsEnabled"
                    (click)="toggleFolderLinkSharing(true)">
                    Enable
                </div>
            </div>

            <div class="link-sharing-input">{{ sharedFolderLink }}</div>
        </div>
    </div>

    <div modal class="enter-username-modal modal" *ngIf="modals.enterUsername">
        <div class="modal-background"></div>
        <div class="modal-container">
            <enter-username
                (close)="closeModal('enterUsername')"></enter-username>
        </div>
    </div>

    <div modal class="modal tutorial-modal" *ngIf="tutorialModal">
        <div class="modal-background" (click)="closeTutorialModal()"></div>
        <div class="modal-container">
            <div class="modal-title">Welcome to AIVA!</div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="closeTutorialModal()" />
            </div>

            <div class="modal-subtitle">
                To get started, we recommend watching a 2 minutes long tutorial
                that will introduce you to the basics of composing music with
                AIVA.
            </div>

            <div
                class="modal-button modal-skip-tutorial"
                (click)="closeTutorialModal()">
                <img class="tutorial-skip" src="assets/img/close.svg" />Skip
                Tutorial
            </div>
            <div
                class="modal-button modal-blue-button"
                (click)="watchTutorialView()">
                <img
                    class="tutorial-play"
                    src="assets/img/player/play.svg" />Watch Tutorial
            </div>
        </div>
    </div>

    <div id="video-controller-view" *ngIf="watchTutorial">
        <div id="close" (click)="watchTutorial = false"></div>

        <iframe
            id="ytplayer"
            type="text/html"
            width="89%"
            height="85%"
            frameborder="0"
            src="https://www.youtube.com/embed/SR-UWkSTmAQ?vq=hd1080&modestbranding=1&autohide=1&showinfo=0&controls=1&autoplay=1&rel=0"></iframe>

        <div
            class="modal-green-button modal-button"
            (click)="watchTutorial = false">
            Close video & Start composing with AIVA
        </div>
    </div>

    <div
        modal
        class="open-composition-modal modal"
        *ngIf="openCompositionModal">
        <div class="modal-background" (click)="cancelOpenComposition()"></div>
        <div class="modal-container">
            <div class="modal-title">Open composition</div>
            <div class="modal-close">
                <img
                    src="assets/img/close.svg"
                    (click)="cancelOpenComposition()" />
            </div>
            <input
                type="text"
                class="modal-input"
                name="open-composition"
                placeholder="Enter the composition ID here"
                [(ngModel)]="openCompositionID"
                (keydown.enter)="openCompositionByID()"
                autofocus />

            <div class="message-box error" *ngIf="openCompositionIDError">
                <div class="text">
                    This composition does not exist. Please check the
                    composition ID and the account you are using.
                </div>
            </div>

            <div
                class="modal-button modal-text-button"
                (click)="cancelOpenComposition()">
                Cancel
            </div>
            <div
                class="modal-button modal-blue-button"
                (click)="openCompositionByID()">
                Done
            </div>
        </div>
    </div>
</div>
